(() => {
  const initialize = (searchToggle) => {
    const element = searchToggle.element;
    const body = document.body;
    const searchMenu = document.querySelector('.search-menu');
    const header = document.querySelector('.header');
    const alert = document.querySelector('.alert');

    const toggle = (event) => {
      event.preventDefault();

      document.querySelectorAll('.mega-menu').forEach((menu) => menu.classList.remove('mega-menu--active'));

      body.classList.toggle('js-body-search-toggle');

      if (body.classList.contains('js-body-search-toggle')) {
        searchMenu.querySelector('[id*="edit-keys"]').focus();
        alert.classList.add('alert--hide');
        header.classList.add('header--open');
        body.classList.add('no-scroll');
      } else {
        alert.classList.remove('alert--hide');
        header.classList.remove('header--open');
        element.focus();
        body.classList.remove('no-scroll');
      }
    };

    element.addEventListener('click', toggle);
  };

  const searchToggle = stp.setup('search');

  searchToggle.map(initialize);
})();
